import React, {useEffect, useRef} from 'react';

const QuickSightDashboardFrame: React.FC = () => {

    useEffect(() => {
       
    }, []);

    return (
        <iframe
            id="qsframe"
            width="100%"
            height="720"
            src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/781568178664/dashboards/33483ffe-a318-4b4c-bcd7-d56bca20b8fd?directory_alias=qsfinpay-dev"
        ></iframe>
    );
};

export default QuickSightDashboardFrame;
